import React from 'react';
import api from "../../../utils/api"; 
import './Analysis.css';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
  PieChart, Pie, Cell, LineChart, Line, AreaChart, Area
} from 'recharts';

// Цветовая палитра для графиков
const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884D8', '#82CA9D', '#FFC658', '#8DD1E1'];

/*export const Analysis = () => {

  const [data, setData] = React.useState(null)
  React.useEffect(() => {
        api.getAnalysis()
        .then((res)=> {
           console.log(res)
            setData(res)
        })
    }, [])
  if (!data) return <div>Загрузка данных...</div>;
  const { charts, summary, subscriptionStats } = data;

  // Компонент для столбчатой диаграммы
  const BarChartComponent = ({ data, title, xKey = "name", yKey = "value", barColor = "#8884d8" }) => (
    <div className="chart-container">
      <h3>{title}</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={xKey} angle={-45} textAnchor="end" height={80} fontSize={12} />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey={yKey} fill={barColor} name="Количество" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );

  // Компонент для круговой диаграммы
  const PieChartComponent = ({ data, title }) => (
    <div className="chart-container">
      <h3>{title}</h3>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ name, percent }) => `${name} (${(percent * 100).toFixed(0)}%)`}
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip formatter={(value) => [`${value} пользователей`, 'Количество']} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );

  // Компонент для линейного графика
  const LineChartComponent = ({ data, title }) => (
    <div className="chart-container">
      <h3>{title}</h3>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="value" stroke="#8884d8" name="Количество" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );

  // Компонент для статистических карточек
  const StatCard = ({ title, value, subtitle, color = "#0088FE" }) => (
    <div className="stat-card" style={{ borderLeftColor: color }}>
      <div className="stat-value" style={{ color }}>{value}</div>
      <div className="stat-title">{title}</div>
      {subtitle && <div className="stat-subtitle">{subtitle}</div>}
    </div>
  );

  // Компонент для таблицы топ продуктов
  const TopProductsTable = ({ products, title }) => (
    <div className="chart-container">
      <h3>{title}</h3>
      <div className="table-container">
        <table className="products-table">
          <thead>
            <tr>
              <th>Продукт</th>
              <th>Количество</th>
              <th>Процент</th>
            </tr>
          </thead>
          <tbody>
            {products.map((product, index) => (
              <tr key={product.id}>
                <td>
                  <span className="product-rank">{index + 1}</span>
                  {product.name}
                </td>
                <td>{product.count}</td>
                <td>{product.percentage}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <div className="analysis-dashboard">
      <header className="dashboard-header">
        <h1>📊 Аналитика пользователей с платными подписками</h1>
        <div className="header-stats">
          <StatCard 
            title="Всего пользователей" 
            value={subscriptionStats.totalUsers} 
          />
          <StatCard 
            title="С подписками" 
            value={subscriptionStats.paidUsers} 
            subtitle={`${subscriptionStats.paidUsersPercentage}%`}
            color="#00C49F"
          />
        </div>
      </header>

      
      <section className="section">
        <h2>📈 Основная статистика</h2>
        <div className="stats-grid">
          <StatCard 
            title="Средний размер семьи" 
            value={summary.averageFamilySize} 
          />
          <StatCard 
            title="Популярная диета" 
            value={summary.mostPopularDiet} 
          />
          <StatCard 
            title="Популярная утварь" 
            value={summary.mostPopularKitchenware} 
          />
          <StatCard 
            title="Пользователей с настройками" 
            value={summary.usersWithSettings} 
          />
        </div>
      </section>

     //  Демографические данные  
      <section className="section">
        <h2>👥 Демографические данные</h2>
        <div className="charts-row">
          <div className="chart-wrapper">
            <PieChartComponent 
              data={charts.gender} 
              title="Распределение по полу" 
            />
          </div>
          <div className="chart-wrapper">
            <BarChartComponent 
              data={charts.ages.slice(0, 15)} 
              title="Топ-15 возрастов" 
            />
          </div>
        </div>
      </section>

     // Приемы пищи  
   <section className="section">
  <h2>🍽️ Приемы пищи</h2>
  <div className="charts-row">
    <div className="chart-wrapper">
      <BarChartComponent 
        data={
          charts.powerMode && charts.powerMode[0] && charts.powerMode[0].value
            ? Object.entries(charts.powerMode[0].value).map(([name, value]) => ({ name, value }))
            : []
        } 
        title="Приемы пищи" 
      />
    </div>
    <div className="chart-wrapper">
      <BarChartComponent 
        data={
          charts.powerMode && charts.powerMode[1] && charts.powerMode[1].value
            ? Object.entries(charts.powerMode[1].value).map(([name, value]) => ({ name, value }))
            : []
        } 
        title="Типы блюд" 
        barColor="#00C49F"
      />
    </div>
  </div>
</section>

    // Диеты и утварь 
      <section className="section">
        <h2>🥗 Предпочтения в питании</h2>
        <div className="charts-row">
          <div className="chart-wrapper">
            <BarChartComponent 
              data={charts.dietTypes.slice(0, 10)} 
              title="Топ-10 типов диет" 
            />
          </div>
          <div className="chart-wrapper">
            <BarChartComponent 
              data={charts.kitchenware.slice(0, 10)} 
              title="Топ-10 кухонной утвари" 
              barColor="#FF8042"
            />
          </div>
        </div>
      </section>

      // Время готовки и калории  
      <section className="section">
        <h2>⏱️ Время и калории</h2>
        <div className="charts-row">
          <div className="chart-wrapper">
            <BarChartComponent 
              data={charts.cookingTime.slice(0, 15)} 
              title="Топ-15 времени готовки (минуты)" 
            />
          </div>
          <div className="chart-wrapper">
            <BarChartComponent 
              data={charts.calories.slice(0, 15)} 
              title="Топ-15 диапазонов калорий" 
              barColor="#FFBB28"
            />
          </div>
        </div>
      </section>

      // Стоп-лист 
      <section className="section">
        <h2>🚫 Стоп-лист продуктов</h2>
        <div className="charts-row">
          <div className="chart-wrapper">
            <TopProductsTable 
              products={charts.topProducts} 
              title="Топ-10 исключаемых продуктов" 
            />
          </div>
          <div className="chart-wrapper">
            <PieChartComponent 
              data={charts.calorieTracking} 
              title="Учет калорий и нутриентов" 
            />
          </div>
        </div>
      </section>

      // Дополнительная статистика  
      <section className="section">
        <h2>📋 Дополнительные настройки</h2>
        <div className="charts-row">
          <div className="chart-wrapper">
            <PieChartComponent 
              data={charts.familySize} 
              title="Размер семьи" 
            />
          </div>
          <div className="chart-wrapper">
            <PieChartComponent 
              data={charts.periodAnalysis} 
              title="Период анализа" 
            />
          </div>
          <div className="chart-wrapper">
            <BarChartComponent 
              data={charts.macronutrients.slice(0, 10)} 
              title="Топ-10 макронутриентов" 
              barColor="#8884D8"
            />
          </div>
        </div>
      </section>

     //  Детальная статистика по стоп-листу 
      <section className="section">
        <h2>📊 Детальная статистика стоп-листа</h2>
        <div className="stats-grid">
          <StatCard 
            title="Всего уникальных продуктов в стоп-листах" 
            value={charts.stopProducts.length} 
          />
          <StatCard 
            title="Самый популярный исключаемый продукт" 
            value={charts.topProducts[0]?.name || 'Нет данных'} 
          />
          <StatCard 
            title="Пользователей с этим продуктом" 
            value={`${charts.topProducts[0]?.percentage || 0}%`} 
          />
        </div>
      </section>
    </div>
  );
};*/

export const Analysis = () => {
  const [data, setData] = React.useState(null);

  React.useEffect(() => {
    api.getAnalysis()
      .then((res) => {
        console.log('Аналитика:', res);
        setData(res);
      })
      .catch((err) => {
        console.error('Ошибка загрузки аналитики:', err);
      });
  }, []);

  if (!data) return <div className="loading">Загрузка данных...</div>;

  const { 
    charts, 
    summary, 
    subscriptionStats, 
    subscriptionAnalysis,
    recipeAnalysis 
  } = data;

  // Компонент для столбчатой диаграммы
  const BarChartComponent = ({ data, title, xKey = "name", yKey = "value", barColor = "#8884d8", barName = "Количество" }) => (
    <div className="chart-container">
      <h3>{title}</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis 
            dataKey={xKey} 
            angle={data && data.length > 5 ? -45 : 0} 
            textAnchor={data && data.length > 5 ? "end" : "middle"} 
            height={data && data.length > 5 ? 80 : 40} 
            fontSize={12} 
          />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey={yKey} fill={barColor} name={barName} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );

  // Компонент для круговой диаграммы
  const PieChartComponent = ({ data, title, labelFormat = "name" }) => (
    <div className="chart-container">
      <h3>{title}</h3>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ name, percent, value }) => 
              labelFormat === "value" ? `${value}` : `${name} (${(percent * 100).toFixed(0)}%)`
            }
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
          >
            {data && data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip formatter={(value, name) => [`${value}`, name]} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );

  // Компонент для линейного графика
  const LineChartComponent = ({ data, title, dataKey = "value", lineName = "Количество" }) => (
    <div className="chart-container">
      <h3>{title}</h3>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line 
            type="monotone" 
            dataKey={dataKey} 
            stroke="#8884d8" 
            name={lineName} 
            activeDot={{ r: 8 }} 
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );

  // Компонент для статистических карточек
  const StatCard = ({ title, value, subtitle, color = "#0088FE" }) => (
    <div className="stat-card" style={{ borderLeftColor: color }}>
      <div className="stat-value" style={{ color }}>{value}</div>
      <div className="stat-title">{title}</div>
      {subtitle && <div className="stat-subtitle">{subtitle}</div>}
    </div>
  );

  // Компонент для таблицы
  const TableComponent = ({ data, title, columns }) => (
    <div className="chart-container">
      <h3>{title}</h3>
      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              {columns.map((col, index) => (
                <th key={index}>{col.title}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data && data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((col, colIndex) => (
                  <td key={colIndex}>
                    {col.render ? col.render(row) : row[col.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  // Компонент для топ рецептов
  const TopRecipesTable = ({ recipes, title, type = "likes" }) => (
    <TableComponent
      title={title}
      data={recipes}
      columns={[
        { 
          title: "Рецепт", 
          key: "name", 
          render: (row) => (
            <>
              <span className="recipe-rank" style={{ marginRight: '8px' }}>
                {recipes.indexOf(row) + 1}
              </span>
              {row.name}
            </>
          )
        },
        { 
          title: type === "likes" ? "Лайки" : "Дизлайки", 
          key: type === "likes" ? "likes" : "dislikes" 
        },
        { 
          title: "Категория", 
          key: "category" 
        },
        { 
          title: "Соотношение", 
          key: type === "likes" ? "likeRatio" : "dislikeRatio"
        }
      ]}
    />
  );

  return (
    <div className="analysis-dashboard">
      {/* Заголовок и общая статистика */}
      <header className="dashboard-header">
        <h1>📊 Комплексная аналитика платформы</h1>
        <div className="header-stats">
          <StatCard 
            title="Всего пользователей" 
            value={subscriptionStats?.totalUsers || 0} 
          />
          <StatCard 
            title="С подписками" 
            value={subscriptionStats?.paidUsers || 0} 
            subtitle={`${subscriptionStats?.paidUsersPercentage || 0}%`}
            color="#00C49F"
          />
          <StatCard 
            title="Активных подписок" 
            value={subscriptionAnalysis?.summary?.totalActiveSubscriptions || 0} 
            subtitle={`${subscriptionAnalysis?.summary?.activeUsersPercentage || 0}%`}
            color="#FF8042"
          />
          <StatCard 
            title="Всего рецептов" 
            value={recipeAnalysis?.summary?.totalRecipes || 0} 
            color="#8884D8"
          />
        </div>
      </header>

      {/* Раздел 1: Статистика подписок */}
      <section className="section">
        <h2>💰 Анализ подписок</h2>
        
        {/* Сводка по подпискам */}
        <div className="stats-grid">
          <StatCard 
            title="Авто-продление" 
            value={`${subscriptionAnalysis?.details?.autoRenewRate || 0}%`} 
            subtitle="активировано"
          />
          <StatCard 
            title="Средняя длительность" 
            value={`${subscriptionAnalysis?.summary?.avgSubscriptionDays || 0} дней`} 
          />
          <StatCard 
            title="Самая популярная подписка" 
            value={subscriptionAnalysis?.details?.mostPopularType || "Нет данных"} 
          />
          <StatCard 
            title="Самый популярный период" 
            value={subscriptionAnalysis?.details?.mostPopularPeriod || "Нет данных"} 
          />
        </div>

        {/* Графики подписок */}
        <div className="charts-row">
          <div className="chart-wrapper">
            <PieChartComponent 
              data={subscriptionAnalysis?.charts?.byType || []} 
              title="Распределение по типам подписок" 
            />
          </div>
          <div className="chart-wrapper">
            <BarChartComponent 
              data={subscriptionAnalysis?.charts?.byPeriod || []} 
              title="Распределение по периодам" 
              barColor="#00C49F"
            />
          </div>
          <div className="chart-wrapper">
            <LineChartComponent 
              data={subscriptionAnalysis?.charts?.byMonth || []} 
              title="Активность подписок по месяцам" 
            />
          </div>
        </div>
      </section>

      {/* Раздел 2: Анализ популярности рецептов */}
      <section className="section">
        <h2>🥘 Популярность рецептов</h2>
        
        {/* Сводка по рецептам */}
        <div className="stats-grid">
          <StatCard 
            title="Всего лайков" 
            value={recipeAnalysis?.summary?.totalLikes || 0} 
          />
          <StatCard 
            title="Всего дизлайков" 
            value={recipeAnalysis?.summary?.totalDislikes || 0} 
            color="#FF6B6B"
          />
          <StatCard 
            title="Среднее лайков на рецепт" 
            value={recipeAnalysis?.summary?.avgLikesPerRecipe || 0} 
          />
          <StatCard 
            title="Соотношение лайк/дизлайк" 
            value={recipeAnalysis?.summary?.likeToDislikeRatio || 0} 
          />
        </div>

        {/* Топ рецептов */}
        <div className="charts-row">
          <div className="chart-wrapper">
            <TopRecipesTable 
              recipes={recipeAnalysis?.topRecipes?.byLikes || []} 
              title="Топ-5 рецептов по лайкам" 
              type="likes"
            />
          </div>
          <div className="chart-wrapper">
            <TopRecipesTable 
              recipes={recipeAnalysis?.topRecipes?.byDislikes || []} 
              title="Топ-5 рецептов по дизлайкам" 
              type="dislikes"
            />
          </div>
        </div>

        {/* Графики соотношений */}
        <div className="charts-row">
          <div className="chart-wrapper">
            <PieChartComponent 
              data={recipeAnalysis?.charts?.likeDislikeRatio || []} 
              title="Соотношение лайк/дизлайк" 
            />
          </div>
          <div className="chart-wrapper">
            <BarChartComponent 
              data={recipeAnalysis?.charts?.likesDistribution?.slice(0, 10) || []} 
              title="Топ-10 рецептов по лайкам" 
              barColor="#0088FE"
            />
          </div>
          <div className="chart-wrapper">
            <BarChartComponent 
              data={recipeAnalysis?.charts?.dislikesDistribution?.slice(0, 10) || []} 
              title="Топ-10 рецептов по дизлайкам" 
              barColor="#FF8042"
            />
          </div>
        </div>
      </section>

      {/* Раздел 3: Пользовательские настройки (существующие данные) */}
      <section className="section">
        <h2>👥 Демографические данные пользователей</h2>
        
        <div className="charts-row">
          <div className="chart-wrapper">
            <PieChartComponent 
              data={charts?.gender || []} 
              title="Распределение по полу" 
            />
          </div>
          <div className="chart-wrapper">
            <BarChartComponent 
              data={charts?.ages?.slice(0, 15) || []} 
              title="Топ-15 возрастов" 
              barColor="#00C49F"
            />
          </div>
          <div className="chart-wrapper">
            <PieChartComponent 
              data={charts?.familySize || []} 
              title="Размер семьи" 
            />
          </div>
        </div>
      </section>

      {/* Раздел 4: Пищевые предпочтения */}
      <section className="section">
        <h2>🍽️ Пищевые предпочтения</h2>
        
        <div className="charts-row">
          <div className="chart-wrapper">
            <BarChartComponent 
              data={charts?.dietTypes?.slice(0, 10) || []} 
              title="Топ-10 типов диет" 
            />
          </div>
          <div className="chart-wrapper">
            <BarChartComponent 
              data={charts?.kitchenware?.slice(0, 10) || []} 
              title="Топ-10 кухонной утвари" 
              barColor="#FF8042"
            />
          </div>
        </div>
      </section>

      {/* Раздел 5: Время и калории */}
      <section className="section">
        <h2>⏱️ Время готовки и калории</h2>
        
        <div className="charts-row">
          <div className="chart-wrapper">
            <BarChartComponent 
              data={charts?.cookingTime?.slice(0, 15) || []} 
              title="Топ-15 времени готовки (минуты)" 
            />
          </div>
          <div className="chart-wrapper">
            <BarChartComponent 
              data={charts?.calories?.slice(0, 15) || []} 
              title="Топ-15 диапазонов калорий" 
              barColor="#FFBB28"
            />
          </div>
        </div>
      </section>

      {/* Раздел 6: Стоп-лист и настройки */}
      <section className="section">
        <h2>🚫 Стоп-лист и настройки</h2>
        
        <div className="stats-grid">
          <StatCard 
            title="Всего продуктов в стоп-листах" 
            value={summary?.totalUniqueStopProducts || 0} 
          />
          <StatCard 
            title="Среднее продуктов на пользователя" 
            value={summary?.averageStopProducts || 0} 
          />
          <StatCard 
            title="Пользователей с настройками" 
            value={summary?.usersWithSettings || 0} 
          />
          <StatCard 
            title="Средний размер семьи" 
            value={summary?.averageFamilySize || 0} 
          />
        </div>

        <div className="charts-row">
          <div className="chart-wrapper">
            <TableComponent
              title="Топ-10 исключаемых продуктов"
              data={charts?.topProducts || []}
              columns={[
                { title: "Продукт", key: "name" },
                { title: "Количество", key: "count" },
                { title: "Процент", key: "percentage", render: (row) => `${row.percentage}%` }
              ]}
            />
          </div>
          <div className="chart-wrapper">
            <PieChartComponent 
              data={charts?.calorieTracking || []} 
              title="Учет калорий и нутриентов" 
            />
          </div>
        </div>
      </section>

      {/* Раздел 7: Дополнительная статистика */}
      <section className="section">
        <h2>📊 Дополнительная статистика</h2>
        
        <div className="charts-row">
          <div className="chart-wrapper">
            <PieChartComponent 
              data={charts?.periodAnalysis || []} 
              title="Период анализа" 
            />
          </div>
          <div className="chart-wrapper">
            <BarChartComponent 
              data={charts?.macronutrients?.slice(0, 10) || []} 
              title="Топ-10 макронутриентов" 
              barColor="#8884D8"
            />
          </div>
          <div className="chart-wrapper">
            {charts?.powerMode && charts.powerMode.meals && (
              <BarChartComponent 
                data={Object.entries(charts.powerMode.meals).map(([name, value]) => ({ name, value }))} 
                title="Приемы пищи" 
                barColor="#82CA9D"
              />
            )}
          </div>
        </div>
      </section>
    </div>
  );
};


/*export function Analysis(props) {
   const [data, setData] = React.useState([])
    React.useEffect(() => {
        api.getAnalysis()
        .then((res)=> {
           console.log(res)
            setData(res)
        })
    }, [])
    
    
    
  return (
    <main className='content section__row'>
      <h1></h1> 
      <section className='analiys__section'>
        <h2>Типы питания</h2>
        {Object.values(data).length > 0 && data.diets.length > 0 && 
       <BarChart
       width={500}
       height={300}
       data={data.diets}
       margin={{
         top: 20, right: 30, left: 20, bottom: 5,
       }}
     >
       <CartesianGrid strokeDasharray="3 3" />
       <XAxis dataKey="name" />
       <YAxis />
       <Tooltip />
       <Legend />
       <Bar dataKey="count" fill="#8884d8" />
     </BarChart>
        }
      </section>
      <section className='analiys__section'>
        <h2>Время приготовления</h2>
        {Object.values(data).length > 0 && data.cookingTimes.length > 0 &&  
       <BarChart
       width={500}
       height={300}
       data={data.cookingTimes}
       margin={{
         top: 20, right: 30, left: 20, bottom: 5,
       }}
     >
       <CartesianGrid strokeDasharray="3 3" />
       <XAxis dataKey="time" />
       <YAxis />
       <Tooltip />
       <Legend />
       <Bar dataKey="count" fill="#8884d8" />
     </BarChart>
        }
      </section>
      <section className='analiys__section'>
        <h2>Калорийность</h2>
        <p>Без калорийности: {Object.values(data).length > 0 && data.notcals}</p>
        {Object.values(data).length > 0 && data.cals.length > 0 &&  
       <BarChart
       width={500}
       height={300}
       data={data.cals}
       margin={{
         top: 20, right: 30, left: 20, bottom: 5,
       }}
     >
       <CartesianGrid strokeDasharray="3 3" />
       <XAxis dataKey="cals" />
       <YAxis />
       <Tooltip />
       <Legend />
       <Bar dataKey="count" fill="#8884d8" />
     </BarChart>
        }
      </section>
      <section className='analiys__section'>
        <h2>Приемы пищи</h2>
        {Object.values(data).length > 0 && data.meals.length > 0 &&  
       <BarChart
       width={500}
       height={300}
       data={data.meals}
       margin={{
         top: 20, right: 30, left: 20, bottom: 5,
       }}
     >
       <CartesianGrid strokeDasharray="3 3" />
       <XAxis dataKey="nameRu" />
       <YAxis />
       <Tooltip />
       <Legend />
       <Bar dataKey="count" fill="#8884d8" />
     </BarChart>
        }
      </section>
      <section className='analiys__section'>
        <h2>Оборудование</h2>
        {Object.values(data).length > 0 && data.wares.length > 0 &&  
       <BarChart
       width={500}
       height={300}
       data={data.wares}
       margin={{
         top: 20, right: 30, left: 20, bottom: 5,
       }}
     >
       <CartesianGrid strokeDasharray="3 3" />
       <XAxis dataKey="name" />
       <YAxis />
       <Tooltip />
       <Legend />
       <Bar dataKey="count" fill="#8884d8" />
     </BarChart>
        }
      </section>
      <section className='analiys__section'>
        <h2>Период готовки</h2>
        {Object.values(data).length > 0 && data.period.length > 0 &&  
       <BarChart
       width={500}
       height={300}
       data={data.period}
       margin={{
         top: 20, right: 30, left: 20, bottom: 5,
       }}
     >
       <CartesianGrid strokeDasharray="3 3" />
       <XAxis dataKey="period" />
       <YAxis />
       <Tooltip />
       <Legend />
       <Bar dataKey="count" fill="#8884d8" />
     </BarChart>
        }
      </section>
      <section className='analiys__section'>
        <h2>Продукты</h2>
        <div className='analisys__block'>
        {Object.values(data).length > 0 && data.product.length > 0 &&  
          data.product.map(produc => (
              <div className='analisys__item'>
              <p>{produc.nameRu}</p>
              <p>{produc.count}</p>
              </div>
          ))
        }
        </div>
      </section>
      <section className='analiys__section'>
        <h2>Лайки</h2>
        <div className='analisys__block'>
        {Object.values(data).length > 0 && data.likes.length > 0 &&  
          data.likes.map(like => (
              <div className='analisys__item'>
              <p>{like.name}</p>
              <p>{like.count}</p>
              </div>
          ))
        }
        </div>
      </section>
    </main>
)
   
}*/
